/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

// Component imports
import { Form, Input, Select } from 'antd';

// Misc imports
import { useBotLanguage } from '../../../../utils/hooks/useBotLanguage';
import { MEDIA_TYPES } from '../../../../constants/flowGraph';
import { URL_REGEX } from '../../../../constants/regex';

// Constant declarations
const { Option } = Select;

const MediaNodeForm = () => {
  const { t } = useTranslation();
  const { isEditingPrimaryLanguage } = useBotLanguage();

  return (
    <Fragment>
      <Form.Item
        label={t('URL')}
        name={['data', 'mediaUrl']}
        rules={[
          {
            required: true,
            message: t('URL cannot be blank.')
          },
          {
            validator: async (rule, value) => {
              try {
                if (value && !URL_REGEX.test(value)) {
                  throw new Error(rule.message);
                }
              } catch {
                throw new Error(rule.message);
              }
            },
            message: t('Please enter a valid URL')
          }]}
      >
        <Input
          placeholder={t('Enter the media URL')}
          size="large"
          disabled={!isEditingPrimaryLanguage}
        />
      </Form.Item>

      <Form.Item
        label={t('Thumbnail')}
        name={['data', 'posterUrl']}
        rules={[
          {
            required: false
          },
          {
            validator: async (rule, value) => {
              try {
                if (value && !URL_REGEX.test(value)) {
                  throw new Error(rule.message);
                }
              } catch {
                throw new Error(rule.message);
              }
            },
            message: t('Please enter a valid URL')
          }]}
      >
        <Input
          placeholder={t('Enter the thumbnail URL')}
          size="large"
          disabled={!isEditingPrimaryLanguage}
        />
      </Form.Item>

      <Form.Item
        label={t('Media type')}
        name={['data', 'mediaType']}
        rules={[{ required: true, message: t('Please select a media type.') }]}
      >
        <Select
          placeholder={t('Select a media type')}
          size="large"
          disabled={!isEditingPrimaryLanguage}
        >
          {
            Object.entries(MEDIA_TYPES).map(([key, value]) => (
              <Option key={key} value={value}>{t(key, { context: 'media type' })}</Option>
            ))
          }
        </Select>
      </Form.Item>
    </Fragment>
  );
};

export default MediaNodeForm;
